/**
 * manage 模块 API 前缀：python → /v1，java → /java/v1
 */
export function textbookApiPrefix(): string {
  const backend = (import.meta.env.VITE_TEXTBOOK_BACKEND as string) || 'python'
  return backend === 'java' ? '/java/v1' : '/v1'
}

export function isJavaTextbookBackend(): boolean {
  return ((import.meta.env.VITE_TEXTBOOK_BACKEND as string) || 'python') === 'java'
}
